export const SIGNATURE_ALLOWED_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp",
];

export const SIGNATURE_MAX_SIZE = 5 * 1024 * 1024;

export const getUserDigitalSignatureUrl = (user) =>
  user?.digitalSignature?.url || null;

export const isSupportedSignatureFile = (file) =>
  Boolean(file && SIGNATURE_ALLOWED_MIME_TYPES.includes(file.type));

export const isSignatureFileSizeValid = (file) =>
  Boolean(file && file.size <= SIGNATURE_MAX_SIZE);

export const isValidSignatureUrl = (value) => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return false;

  try {
    const parsed = new URL(trimmed);
    return ["http:", "https:"].includes(parsed.protocol);
  } catch {
    return false;
  }
};
